export type AppRole = 'admin' | 'ti' | 'rh' | 'secretaria' | 'coordenacao' | 'professor' | 'laboratorio' | 'infraestrutura' | 'financeiro' | 'provas' | 'reprografia' | 'gestor_evento' | 'captacao' | 'aluno' | 'bibliotecario';

export const ROLE_HIERARCHY: AppRole[] = [
  'admin',
  'ti',
  'rh',
  'secretaria',
  'coordenacao',
  'professor',
  'laboratorio'
];

export const checkRole = (userRoles: AppRole[], requiredRole: AppRole): boolean => {
  if (userRoles.includes('admin')) return true;
  
  const requiredIndex = ROLE_HIERARCHY.indexOf(requiredRole);
  if (requiredIndex === -1) return userRoles.includes(requiredRole);
  
  return userRoles.some(role => {
    const userIndex = ROLE_HIERARCHY.indexOf(role);
    return userIndex !== -1 && userIndex <= requiredIndex;
  });
};

export const checkAnyRole = (userRoles: AppRole[], requiredRoles: AppRole[]): boolean => {
  return requiredRoles.some(role => checkRole(userRoles, role));
};

export type Permission = 'view' | 'edit' | 'hidden';

export const getFieldPermission = (field: string, roles: AppRole[]): Permission => {
  if (roles.includes('admin') || roles.includes('ti')) return 'edit';
  if (roles.includes('rh')) return 'edit';
  return 'view';
};
